import _ from 'lodash';
export class ObjectPanelComponent {
    key;
    label;
    title;
    type;
    collapsed;
    collapsible;
    components;
    constructor(config) {
        _.merge(this, config);
        this.key = `${config.key}-Panel`;
        this.label = config.label || _.startCase(config.key);
        this.title = this.label;
        this.type = 'panel';
        this.collapsed = _.get(config, ['collapsed'], true);
        this.collapsible = _.get(config, ['collapsible'], true);
        this.components = [
            {
                key: config.key,
                label: this.label,
                type: 'container',
                components: _.get(config, 'components', [])
            }
        ];
    }
}
